import React from "react";
import { FlexCol } from "../generic/Containers";
import { BCPrimaryButton } from "../generic/BCButtons";
import { useGlobalState } from "../../GlobalState";
import "./FinalCTASection.css";

export const FinalCTASection: React.FC = () => {
    const { setShowAuthModal, setAuthModalMode } = useGlobalState();

    const handleJoinClick = () => {
        setAuthModalMode('register');
        setShowAuthModal(true);
    };

    return (
        <FlexCol className="final-cta-section" align="center" gap={1.5}>
            <h2 className="final-cta-header">Ready to Start Your Journey?</h2>
            <p className="final-cta-subtext">Join thousands of developers building real-world skills</p>
            <BCPrimaryButton 
                text="JOIN FOR FREE"
                onClick={handleJoinClick}
                className="landing-primary-cta-button"
            />
        </FlexCol>
    );
};
